var _style, _path, _circle, _path2, _path3, _path4, _polygon, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "579 -634.3 1769.8 634.3",
    style: {
      enableBackground: "new 579 -634.3 1769.8 634.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#13007C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2218.9-200l-5.7-0.5c-9.2-0.8-16.2-8.6-16-17.9l4.7-273c2.1-22.4,21.9-39,44.4-36.9l0,0 c22.4,2.1,39,21.9,36.9,44.4l-45.1,269.2C2236.4-205.5,2228.1-199.1,2218.9-200z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2212,
    cy: -156.2,
    r: 27.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M821.3-403.3C747.7-403.3,688-343.6,688-270s59.7,133.3,133.3,133.3S954.6-196.3,954.6-270 S894.9-403.3,821.3-403.3z M822.7-208.1c-34.9,0-63.3-28.3-63.3-63.3c0-34.9,28.3-63.3,63.3-63.3c34.9,0,63.3,28.3,63.3,63.3 C885.9-236.4,857.6-208.1,822.7-208.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1384.5-403.3c-73.6,0-133.3,59.7-133.3,133.3s59.7,133.3,133.3,133.3s133.3-59.7,133.3-133.3 S1458.1-403.3,1384.5-403.3z M1383.1-208.1c-34.9,0-63.3-28.3-63.3-63.3c0-34.9,28.3-63.3,63.3-63.3s63.3,28.3,63.3,63.3 S1418.1-208.1,1383.1-208.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2046.5-387.6c-13.1-5.4-27.4-8.3-42.4-8.3c-18.4,0-35.7,4.4-51,12.2v-19.6h-69.8l0,0v262.1l0,0l0,0h69.8l0,0 v-42.5V-280c0-25.9,21-46.8,46.8-46.8c24.2,0,44.1,18.3,46.6,41.8v10v95.3v38.6h69.8v-142.6C2116.3-330.7,2087.5-370.9,2046.5-387.6 z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1757.2,-269.6 1756.7,-268 1715,-403.3 1687.2,-403.3 1659.3,-403.3 1617.6,-268 1617.1,-269.6  1571,-403.3 1497.3,-403.3 1586.6,-142.8 1646.3,-142.8 1653,-164.4 1669.2,-213.6 1669.3,-213.7 1669.6,-214.6 1687.2,-267.9  1704.8,-214.6 1705.1,-213.7 1705.1,-213.6 1721.4,-164.4 1728,-142.8 1787.7,-142.8 1877,-403.3 1803.3,-403.3 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1159.8-388.1c-18.5-9.7-39.6-15.2-61.9-15.2c-73.6,0-133.3,59.7-133.3,133.3s59.7,133.3,133.3,133.3 c22.3,0,43.4-5.5,61.9-15.2c42.4-22.3,71.4-66.8,71.4-118.1v-210.9l-71.4-39.4V-388.1z M1096.5-208.1c-34.9,0-63.3-28.3-63.3-63.3 c0-34.9,28.3-63.3,63.3-63.3c34.9,0,63.3,28.3,63.3,63.3S1131.5-208.1,1096.5-208.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1752f3a2.svg";
export { ForwardRef as ReactComponent };